import { Link, Navigate, Route, Routes, useParams } from "react-router";
import { Shell } from "./components/Shell";
import { AuthVerify, Login, Signup } from "./pages/Auth";
import { Connect } from "./pages/Connect";
import { Alerts, Apps, Home, People, Plan, Problems, Weekly } from "./pages/Dashboard";
import { ProblemPage } from "./pages/Problem";
import { Rules } from "./pages/Rules";
import { AppServices, ServiceActivity } from "./pages/Services";
import { SetupConnect, SetupHelper, SetupPeople } from "./pages/Setup";
import { Sources } from "./pages/Sources";

/** Every route, used by the router and by the smoke test. */
export const ROUTES = [
  "/",
  "/signup",
  "/login",
  "/auth/verify",
  "/connect?code=BCDF-GHJK",
  "/setup",
  "/setup/people",
  "/setup/helper",
  "/home",
  "/problems",
  "/problems/prb_payments",
  "/apps",
  "/apps/prj_shop",
  "/apps/prj_shop/services/checkout",
  "/rules",
  "/people",
  "/alerts",
  "/plan",
  "/weekly",
] as const;

function NotFound() {
  return (
    <main id="main" className="center">
      <title>Not found · Pagerless</title>
      <div className="win auth">
        <h1 className="h2">We can't find that page</h1>
        <p className="muted">
          <Link to="/home">Go to your dashboard</Link>
        </p>
      </div>
    </main>
  );
}

/** Alert short links (/p/prb_…) open the app on a phone; in a browser they go to the problem. */
function ShortProblemLink() {
  const { id = "" } = useParams();
  return <Navigate to={`/problems/${encodeURIComponent(id)}`} replace />;
}

export function App() {
  return (
    <Routes>
      {/* The marketing site is apps/site on pagerless.dev; the app's own root is the dashboard (or sign-in). */}
      <Route path="/" element={<Navigate to="/home" replace />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/login" element={<Login />} />
      <Route path="/auth/verify" element={<AuthVerify />} />
      <Route path="/p/:id" element={<ShortProblemLink />} />
      <Route path="/connect" element={<Connect />} />
      <Route path="/setup" element={<SetupConnect />} />
      <Route path="/setup/people" element={<SetupPeople />} />
      <Route path="/setup/helper" element={<SetupHelper />} />
      <Route element={<Shell />}>
        <Route path="/home" element={<Home />} />
        <Route path="/problems" element={<Problems />} />
        <Route path="/problems/:id" element={<ProblemPage />} />
        <Route path="/apps" element={<Apps />} />
        <Route path="/apps/:id" element={<AppServices />} />
        <Route path="/apps/:id/services/:name" element={<ServiceActivity />} />
        <Route path="/apps/:id/tools" element={<Sources />} />
        <Route path="/rules" element={<Rules />} />
        <Route path="/people" element={<People />} />
        <Route path="/alerts" element={<Alerts />} />
        <Route path="/plan" element={<Plan />} />
        <Route path="/weekly" element={<Weekly />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
